module.exports = __webpack_public_path__ + "img/KGoldtrebol.d6d0757e.png";